import classnames from 'classnames';
import { FunctionComponent } from 'react';

type VettedCheckmarkProps = {
    className?: string;
};

const VettedCheckmark: FunctionComponent<VettedCheckmarkProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'vetted-checkmark'}
            viewBox="0 0 250 250"
        >
            <path d="M67.4 109.1l9.2-7.7 46.3 55.2L231.5 36.3l8.8 7.9-117.6 130.5z" />
            <path d="M238.5 101.5c1.6 7.6 2.4 15.5 2.4 23.6 0 63.9-52 115.8-115.8 115.8S9.3 189 9.3 125.2 61.2 9.3 125.1 9.3c20.9 0 40.5 5.6 57.5 15.3l6.2-6.8C170.1 6.7 148.3.3 125.1.3 56.3.3.3 56.3.3 125.2S56.3 250 125.1 250s124.8-56 124.8-124.8c0-11-1.4-21.6-4.1-31.8l-7.3 8.1z" />
        </svg>
    );
};
export default VettedCheckmark;
